































import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "webhooks-provider": () =>
      import("@/components/app/admin/settings/webhooks/webhooksProvider.vue"),
    "webhooks-table-view": () =>
      import("@/components/app/admin/settings/webhooks/webhooksTableView.vue")
  }
})
export default class WebhooksListing extends Vue {}
